<template>
  <div class="SideBar fs18">
    <div class="menu wxkf">
      <div>微信客服</div>
      <my_image id="kf" :src="kf.src" :width="kf.width"></my_image>
    </div>
    <div class="top" @click="scrollToTop">
      <my_image :src="arrow.src" :width="arrow.width"></my_image>
      <div>
        TOP
      </div>
    </div>
    <!-- <div class="tips">
         <div class="text fs14">{{tip}}</div>
         <div class="img">
         <my_image :src="qr.src" :width="qr.width"></my_image>
         </div>
         </div> -->
  </div>
</template>

<script>
 import Link from '@/components/Link.vue';
 import MyImage from '@/components/Image.vue';
 import ArrowTop from '@/assets/image/sidebar/arrow-top.png';
 export default {
   name: 'SideBar',
   props: ['links'],
   computed: {
     kf() {
       return {
         src: '/oss/aialgorithm/images/sidebar/aialgorithm-kf.png',
         width: '150px'
       }
     },
     kc() {
       return {
         src: '/oss/images/sidebar/jskc.png',
         width: '150px'
       }
     },
     arrow() {
       return {
         src: ArrowTop,
         width: '0.9vw'
       }
     },
     qr () {
       return {
         src: '/oss/images/bottombar/coco-qr.png',
         width: '5vw'
       }
     },
     tip() {
       return '如果关卡遇到困难，请扫描微信二维码。回复关卡编号可得到的关卡解法，如回复“1”，可得到第一关“1. Kithgard地牢”的解法。'
     }
   },
   methods:{
     scrollToTop () {
       window.scrollTo(0, 0);
     }
   },
   components: {
     side_link: Link,
     my_image: MyImage
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .SideBar{
   position: fixed;
   z-index: 9999;
   width: 5.73vw;
   height: 4.3vw;
   right: 6.25vw;
   bottom: 2vw;
   border-radius: 5px;
   background-color: var(--blue);

   color: white;
   padding-top: 0.9vw;
   padding-bottom: 0.9vw;
 }
 .SideBar, .SideBar .top{
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: space-between;
 }
 .SideBar .menu{
   width: 5.73vw;
   height: 2.2em;
   display: flex;
   justify-content:center;
   align-items:center;
 }
 .SideBar .top{
   margin-top: 0.4vw;
   width: 5vw;
 }
 .SideBar .top>div{
   color: #CBCFEE;
 }
 .SideBar>div{
   cursor: pointer;
 }
 .tips{
   display: none;
   position: absolute;
   top:  2.14vw;
   left: 6.8vw;
   flex-direction: column;
   justify-content:center;
   align-items:center;
   width: 12.51vw;
   height: 10vw;
   color:#1E254B;
   background-color: rgba(255,255,255,0.5);
   border-radius: 0.3vw;
 }
 .tips::after{
  content: " ";
  position: absolute;
  top: 15%; /* At the bottom of the tooltip */
  right: 100%;
  margin-left: -.7vw;
  border-width: .7vw;
  border-style: solid;
  border-color: transparent  rgba(255,255,255,0.5)transparent transparent;
 }
 .tips>.text{
   width: 10.521vw;
 }
 .tips> .img{
 }
 .menu:nth-child(2):hover ~ .tips{
   display: flex;
 }
  .wxkf {
    position: relative;
  }
  .wxkf:hover > #kf{
    display: block;
  }
  .wxkf #kf{
    position: absolute;
    right: 100%;
    display: none;
  }
  .jskc {
    position: relative;
  }
  .jskc:hover > #kc{
    display: block;
  }
  .jskc #kc{
    position: absolute;
    right: 100%;
    display: none;
  }


 @media (min-width: 320px) and (max-width: 480px) {
.SideBar{
   width: 10.73vw;
   height: 15.3vw;
   bottom: 20vw;
   border-radius: 2px;
   padding-top: 0.9vw;
   padding-bottom: 0.9vw;
  font-size: 1.8vw !important;
 }
.SideBar .menu{
   width: 8.73vw;
   height: 2.2em;
 }

 }
</style>
